var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.28 -87.22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.42,94.28h-1.79c-.19,0-.35-.17-.35-.38,0-.13.05-.25.12-.31l7.1-7.06c.14-.13.35-.13.49,0l7.18,7.06c.14.15.16.4.03.56-.07.1-.17.13-.28.13h-1.79v6.77c0,.21-.16.38-.35.38h-3.02c-.19,0-.36-.17-.36-.38v-4.35h-3.42v4.35c0,.21-.16.38-.35.38h-2.86c-.21,0-.36-.17-.36-.38v-6.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome);
export default __webpack_public_path__ + "static/media/sidebar_home.a21039d9401722e099edacf5dc70d151.svg";
export { ForwardRef as ReactComponent };